import type { IRoute } from '@/shared/models/route.model';
import ConnectionsLayout from '@/connections/layout/ConnectionsLayout';
import { lazy } from 'react';
const Integrations = lazy(() => import('../components/Integrations'));

export const integrationsRoutes: IRoute[] = [
  {
    path: '/integrations',
    component: ConnectionsLayout,
    children: [
      {
        path: ':provider',
        component: Integrations,
      },
    ],
  },
];
